import { computed, makeObservable, observable } from 'mobx';

import { injectable } from '@servicetitan/react-ioc';
import { FeatureFlagsStore } from '@servicetitan/standalone-feature-flags';

interface Features {
    isSMSRegistrationEnabled: boolean;
    isSmsRegistrationSettingsStandaloneDisabled: boolean;
    isCustomizableAttributionWindowEnabled: boolean;
    isCustomizableCustomFieldsEnabled: boolean;
    isAnalyticsDataExportsEnabled: boolean;
    isCampaignManagementAutopilotIntegrationEnabled: boolean;
}

@injectable()
export class FeaturesStore extends FeatureFlagsStore<Features> {
    @observable features: Features = {
        isSMSRegistrationEnabled: false,
        isSmsRegistrationSettingsStandaloneDisabled: false,
        isCustomizableAttributionWindowEnabled: false,
        isCustomizableCustomFieldsEnabled: false,
        isAnalyticsDataExportsEnabled: false,
        isCampaignManagementAutopilotIntegrationEnabled: false,
    };

    @computed get isSMSRegistrationEnabled() {
        return (
            this.features.isSMSRegistrationEnabled &&
            !this.features.isSmsRegistrationSettingsStandaloneDisabled
        );
    }

    constructor() {
        super();
        makeObservable(this);
    }
}
